import { useTranslation } from "react-i18next";
import { ModalBasic } from "../../../../shared/components/ModalBasic";
import { VersionsTable } from "../../VersionsTable";
import { StorageObjectValue } from "../../../../services/api/instances/storageApi/types/service_types";
import { StorageObjectVersion } from "../../../../services/api/instances/storageApi/types/object_types";
import { TModalsIds } from "../../../../app/state/modalSlice/types";
import { useModalSelectors } from "../../../../app/state/modalSlice/hook/use-modal-selectors";
import styles from "./styles.module.css";

interface Props<T extends StorageObjectValue> {
  versions: StorageObjectVersion<T>[];
  closeModal: (id: TModalsIds) => void;
  onOk: (id: string) => void;
}

export const RestoreVersionModal = <T extends StorageObjectValue>(
  props: Props<T>,
) => {
  const restoreVersion = useModalSelectors("restore_version_modal");
  const { t } = useTranslation();

  return (
    <ModalBasic
      open={restoreVersion.isOpen}
      title={t("versioning.restore_modal_title")}
      hasCloseButton
      onClose={() => props.closeModal("restore_version_modal")}
      closeModal={() => props.closeModal("restore_version_modal")}
      className={styles["modal"]}
    >
      <div className={styles.container}>
        <VersionsTable
          versions={props.versions}
          onOk={(id) => {
            props.closeModal("restore_version_modal");
            props.onOk(id);
          }}
        />
      </div>
    </ModalBasic>
  );
};
